<template>
  <div class="disclaimer">
    <!-- <module-logo
      v-if="logoSrc"

      class="disclaimer__logo disclaimer__logo--beacon"
    /> -->
  
    <img
      v-if="logoWidth >= 0"

      :class="[
        `disclaimer__logo`,
        `disclaimer__logo--ext`,
        `disclaimer__logo--${logoRatio}`,
      ]"

      :alt="`${org.program_name} logo`"
      :src="logoSrc"
    >

    <template v-if="!org.is_no_of_sessions_hidden">
      <h3 class="h3 disclaimer__title">{{ `${org.number_of_sessions} covered session${org.number_of_sessions > 1 ? `s` : `` } ${org.session_frequency}` }}</h3>
      <p class="p disclaimer__description">{{ org.program_name }} covers the full cost of up to {{ org.number_of_sessions }} session{{ org.number_of_sessions > 1 ? `s` : `` }} {{ org.session_frequency }}. There’s no co-pay and you don’t need to use your health insurance.</p>
    </template>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Export
export default {
  name: 'module-disclaimer',

  // Data
  data() {
    return {
      logoSizing: false,
      logoHeight: -1,
      logoWidth: -1,
    };
  },
  computed: {
    ...mapGetters('app', [
      'org',
    ]),
    logoSrc() {
      const { logo = {} } = this.org || {};
      return logo.full_size || '';
    },
    logoRatio() {
      const { logoHeight: height, logoWidth: width } = this;

      const ratio = (width !== -1) ? width / height : 1;

      if (ratio >= 1.5) return ratio > 2.5 ? 'very-wide' : 'wide';
      if (ratio <= 0.85) return ratio < 0.5 ? 'very-tall' : 'tall';

      return 'square';
    },
  },
  watch: {
    logoSrc(newLogo, oldLogo) {
      if (newLogo !== oldLogo || (this.logoWidth === -1 && !this.logoSizing)) {
        this.sizeLogo(newLogo);
      }
    },
  },

  // Methods
  methods: {
    imageDimensions(src) {
      return new Promise((resolve, reject) => {
        try {
          const img = new Image();

          img.onload = () => {
            const { naturalWidth: width, naturalHeight: height } = img;
            resolve({ width, height });
          };

          img.onerror = () => reject('There was some problem during the image loading ');

          img.src = src;
        } catch (error) {
          reject(error);
        }
      });
    },
    sizeLogo(src) {
      if (this.logoSizing) return;

      this.logoSizing = true;

      this.imageDimensions(src)
        .then(({ height, width }) => {
          this.logoHeight = height;
          this.logoWidth = width;
          this.logoSizing = false;
        })
        .catch(error => {
          console.error(error);
        });
    },
  },

  // Lifecycle
  created() {
    if (this.logoSrc) {
      this.sizeLogo(this.logoSrc);
    }
  },
};

</script>



// WEBPACK FOOTER //
// Disclaimer.vue?3b827dd8